import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {AccountService} from '../../services/account.service';
import {CurrencyService} from '../../services/currency-service';
import {AccountDTO} from '../../model/accountDTO';
import {TransactionUnassignedComponent} from './unassigned/transaction-unassigned.component';
import {TransactionAssignedComponent} from './assigned/transaction-assigned.component';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
})
export class TransactionComponent implements OnInit {

  @ViewChild(TransactionUnassignedComponent) unassigned: TransactionUnassignedComponent;
  @ViewChild(TransactionAssignedComponent) assigned: TransactionAssignedComponent;

  public account: AccountDTO;
  public message = false;
  public isLoading = false;
  public isLeefgeldRekening = false;
  public count = 0;
  public countAssigned = 0;

  constructor(
    public currency: CurrencyService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    public userService: UserService,
    public translate: TranslateService) {
    translate.use('nl');
    this.route.params.subscribe(params => {
      accountService.get(params['accountId']).subscribe(account => {
        this.account = account;
        setTimeout(() => {
          this.assigned.init();
          this.unassigned.init();
        }, 100);
      });
    });
  }

  ngOnInit() {
    this.isLeefgeldRekening = this.router.url.startsWith('/leefgeldrekening/');
  }

  unassignedCount(event) {
    if (typeof (event) === 'number') { this.count = event; }
  }

  assignedCount(event) {
    if (typeof (event) === 'number') { this.countAssigned = event; }
  }

  undo() {
    this.countAssigned--;
  }

  withdrawAssignmentUpdateCounter() {
    this.count++;
    this.countAssigned--;
  }

  assign() {
    this.countAssigned++;
  }

  tabInit(event: MatTabChangeEvent) {
    event.index === 1 ? this.assigned.init() : this.unassigned.init();
  }
}
